import styled from 'styled-components';
import ControlWithLabel from '../../../cm/common/ControlWithLabel';

export const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #748aa1;
  padding-left: 0.3em;
  margin-bottom: 7px;
`;

export const AlertScoreWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 3px;

  .ant-progress-line {
    width: auto;
    margin-right: 5px;
    margin-left: 3px;
  }

  .ant-progress-inner {
    width: 80px;

    .ant-progress-bg {
      height: 11px !important;
    }
  }

  p {
    margin: 2px 0 0;
    font-weight: 300;
    font-size: 9px;
    line-height: 16px;

    b {
      font-weight: bold;
      font-size: 12px;
    }
  }
`;

export const ProgressText = styled.div`
  font-size: 11px;
  padding: 0;
  margin: 0;
  color: #31394d;
  font-weight: 500;
`;

export const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SmartAssessHeaderPanel = styled.div`
  font-size: 16px;
  font-style: normal;
  color: #31394d;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 12px;
`;

export const SelectBoxContainer = styled.div`
  font-weight: 400;
  min-width: 150px;
  background: #ffffff;
  border: 0px solid #d0d7e3;
  box-sizing: border-box;
  border-radius: 4px;
`;

export const StyledControlWithLabel = styled(ControlWithLabel)`
  font-size: 12px;
  font-weight: 700;
  margin-right: 24px;
`;

export const StyledCmControls = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 24px;
`;
